import { Category } from '../api';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Observer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataUtils {
  private translate = inject(TranslateService);
  private currentlySupportedCategories: Category[] = [
    'JEWELS',
    'INSTRUMENT',
    'GEMSTONE',
    'CAR',
    'ALCOHOL',
    'PROPERTY',
    'SHARES',
    'LOAN',
    'COIN',
    'BANKNOTE',
    'ART',
  ];

  public mapCategories(): ISelectItem<Category>[] {
    return Object.values(Category)
      .map((category, index) => {
        return {
          id: category,
          name: this.translate.instant('categories.' + category),
        };
      })
      .filter(item => {
        return this.currentlySupportedCategories.indexOf(item.id) !== -1;
      });
  }
}

export const fileToBlob = (file: File): Observable<Blob> => {
  return new Observable((observer: Observer<Blob>) => {
    const reader = new FileReader();

    reader.onload = () => {
      observer.next(
        new Blob([reader.result as ArrayBuffer], { type: file.type })
      );
      observer.complete();
    };

    reader.onerror = error => observer.error(error);
    reader.readAsArrayBuffer(file);
  });
};

export interface ISelectItem<T> {
  id: T;
  name: string;
}
